module.exports = __webpack_public_path__ + "img/products.ff96a145.svg";